<div role="navigation" aria-label="XBRL Elements" *ngIf="outcome">
  <div class="mx-2-5">
    <h1 role="definition" class="sub-heading" tabindex="0">
      XBRL Elements
    </h1>
  </div>
  <div class="mx-2-5 mb-1 mt_1">
    <app-location-breadcrumb></app-location-breadcrumb>
  </div>
  <div role="definition" class="mt_1 mx-2-5 flex-display">
    <div class="sub-content-description" tabindex="0">
      XBRL elements that reference this paragraph.
    </div>
    <div class="flex-display ml-0-5">
      <div role="navigation" aria-label="Learn Image" class="cursor-pointer" tabindex="0">
        <img src="../../../assets/icons/Help.svg" class="icon-image-learn-action" alt="Learn">&nbsp;&nbsp;
      </div>
      <div role="navigation" aria-label="Learn" class="cursor-pointer highlight-blue border-bottom-1" tabindex="0">
        <span (click)="redirectToHelp()">Learn</span>
      </div>
    </div>
  </div>

  <div *ngIf="reference.length == 0" class="mt_1 mx-2-5">No XBRL Reference available.</div>
  <div class="mx-2-5 mt-2" *ngFor="let group of reference">
    <div class="mt_1 version-general-header">{{group.subParagraph}}&nbsp;{{group.refRole}}</div>
    <div>
      <ul>
        <li role="navigation" aria-label="Learn" tabindex="0" *ngFor="let list of group.entries" class="mt_1">
          <a class="cursor-pointer highlight-blue xbrlElement" (mouseover)="mouseOverFunctions($event, list.elementName)" (click)="navigateToXBRLContent($event, list.elementName)" (keyup.enter)="navigateToXBRLContent($event, list.elementName)" tabindex="0">{{list.title}}</a>
          &nbsp;<span class="singleLine"><span class="boldFont blackColor">[ </span><span class="text-transform-capitalize blackColor">{{list.status}}</span><span class="boldFont blackColor"> ]</span></span>
        </li>
      </ul>
    </div>
  </div>
</div>
